module.exports = __webpack_public_path__ + "static/ada3-9af4e94aec06ee856ab9bc4c83b7212b.jpg";